
<div>
    <header class="dashboard-header">
        <h1>Service Health Dashboard</h1>
        <p>Real-time monitoring of all system services and their current status</p>
    </header>

    <div class="services-grid">
        <!-- ANPR Service -->
        <div class="service-card">
            <div class="service-header">
                <span class="service-name">ANPR Service</span>
                <span class="status-badge {{healthService?.services?.anpr_service?.status?.toLowerCase()}}">{{healthService?.services?.anpr_service?.status}}</span>
            </div>
            <div class="status-bar-container">
                <div class="status-bar {{healthService?.services?.anpr_service?.status?.toLowerCase()}}"></div>
            </div>
            <div class="uptime-graph">
                <canvas></canvas>
            </div>
            <div class="metrics-grid">
                <div class="metric-item">
                    <div class="metric-label">Uptime</div>
                    <div class="metric-value">{{healthService?.services?.anpr_service?.uptime}}</div>
                </div>
                <div class="metric-item">
                    <div class="metric-label">Response Time</div>
                    <div class="metric-value">234ms</div>
                </div>
                <div class="metric-item">
                    <div class="metric-label">DB Status</div>
                    <div class="metric-value">{{healthService?.services?.anpr_service?.dependencies?.db}}</div>
                </div>
                <div class="metric-item">
                    <div class="metric-label">Cache Status</div>
                    <div class="metric-value">{{healthService?.services?.anpr_service?.dependencies?.cache}}</div>
                </div>
            </div>
            <div class="owner-info">
                <div class="owner-avatar">RP</div>
                <div class="owner-details">
                    <div class="owner-name">{{healthService?.services?.anpr_service?.owner}}</div>
                    <div class="owner-role">Service Owner</div>
                </div>
            </div>
        </div>

        <!-- Payment Service -->
        <div class="service-card">
            <div class="service-header">
                <span class="service-name">Payment Service</span>
                <span class="status-badge {{healthService?.services?.payment_service?.status.toLowerCase()}}">{{healthService?.services?.payment_service?.status}}</span>
            </div>
            <div class="status-bar-container">
                <div class="status-bar {{healthService?.services?.payment_service?.status.toLowerCase()}}"></div>
            </div>
            <div class="uptime-graph">
                <canvas></canvas>
            </div>
            <div class="metrics-grid">
                <div class="metric-item">
                    <div class="metric-label">Uptime</div>
                    <div class="metric-value">{{healthService?.services?.payment_service?.uptime}}</div>
                </div>
                <div class="metric-item">
                    <div class="metric-label">Response Time</div>
                    <div class="metric-value">189ms</div>
                </div>
                <div class="metric-item">
                    <div class="metric-label">DB Status</div>
                    <div class="metric-value">{{healthService?.services?.payment_service?.dependencies?.db}}</div>
                </div>
                <div class="metric-item">
                    <div class="metric-label">Cache Status</div>
                    <div class="metric-value">{{healthService?.services?.payment_service?.dependencies?.cache}}</div>
                </div>
            </div>
            <div class="owner-info">
                <div class="owner-avatar">RP</div>
                <div class="owner-details">
                    <div class="owner-name">{{healthService?.services?.payment_service?.owner}}</div>
                    <div class="owner-role">Service Owner</div>
                </div>
            </div>
        </div>

        <!-- Subscription Service -->
        <div class="service-card">
            <div class="service-header">
                <span class="service-name">Subscription Service</span>
                <span class="status-badge {{healthService?.services?.subscription_service?.status.toLowerCase()}}">{{healthService?.services?.subscription_service?.status}}</span>
            </div>
            <div class="status-bar-container">
                <div class="status-bar {{healthService?.services?.subscription_service?.status.toLowerCase()}}"></div>
            </div>
            <div class="uptime-graph">
                <canvas></canvas>
            </div>
            <div class="metrics-grid">
                <div class="metric-item">
                    <div class="metric-label">Uptime</div>
                    <div class="metric-value">{{healthService?.services?.subscription_service?.uptime}}</div>
                </div>
                <div class="metric-item">
                    <div class="metric-label">Response Time</div>
                    <div class="metric-value">156ms</div>
                </div>
                <div class="metric-item">
                    <div class="metric-label">DB Status</div>
                    <div class="metric-value">{{healthService?.services?.subscription_service?.dependencies?.db}}</div>
                </div>
                <div class="metric-item">
                    <div class="metric-label">Cache Status</div>
                    <div class="metric-value">{{healthService?.services?.subscription_service?.dependencies?.cache}}</div>
                </div>
            </div>
            <div class="owner-info">
                <div class="owner-avatar">RP</div>
                <div class="owner-details">
                    <div class="owner-name">{{healthService?.services?.subscription_service?.owner}}</div>
                    <div class="owner-role">Service Owner</div>
                </div>
            </div>
        </div>

        <!-- ValetX Service -->
        <div class="service-card">
            <div class="service-header">
                <span class="service-name">ValetX Service</span>
                <span class="status-badge {{healthService?.services?.valetx_service?.status?.toLowerCase()}}">{{healthService?.services?.valetx_service?.status}}</span>
            </div>
            <div class="status-bar-container">
                <div class="status-bar {{healthService?.services?.valetx_service?.status?.toLowerCase()}}"></div>
            </div>
            <div class="uptime-graph">
                <canvas></canvas>
            </div>
            <div class="metrics-grid">
                <div class="metric-item">
                    <div class="metric-label">Uptime</div>
                    <div class="metric-value">{{healthService?.services?.valetx_service?.uptime}}</div>
                </div>
                <div class="metric-item">
                    <div class="metric-label">Response Time</div>
                    <div class="metric-value">--</div>
                </div>
                <div class="metric-item">
                    <div class="metric-label">DB Status</div>
                    <div class="metric-value">{{healthService?.services?.valetx_service?.dependencies?.db}}</div>
                </div>
                <div class="metric-item">
                    <div class="metric-label">Cache Status</div>
                    <div class="metric-value">{{healthService?.services?.valetx_service?.dependencies?.cache}}</div>
                </div>
            </div>
            <div class="owner-info">
                <div class="owner-avatar">RP</div>
                <div class="owner-details">
                    <div class="owner-name">{{healthService?.services?.valetx_service?.owner}}</div>
                    <div class="owner-role">Service Owner</div>
                </div>
            </div>
        </div>
    </div>

    <!-- <footer>
        <p>&copy; 2024 Kyra Innovations (LLP) Monitoring. All Rights Reserved.</p>
    </footer> -->
</div>
